import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import NewsActions from 'stores/leadbest-official-website/news/actions'
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { Link } from "react-router-dom";
import MenuTypes from './menuTypes.json'
import languages from 'locales';
import sectionIcon from './../../assets/images/icon-card.png'
import SubmitIcon from './../../assets/images/more-right-black.png'
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Validator, { validation, conactFormData, getMultilevelValue } from 'utils/validator';
import { injectIntl, FormattedMessage } from 'react-intl';
import OtherActions from 'stores/leadbest-official-website/other/actions'
import Snackbar from './../contact/Snackbar'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        btnGroup: {
            padding: 0,
            margin: '0 -8px',
            '& > *': {
                margin: theme.spacing(1)
            }
        },
        filter: {
            width: 278,
            marginLeft: 56,
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                marginLeft: 0,
            },
            '& .filter-item': {
                display: 'flex',
                padding: '20px 0',
                cursor: 'pointer',
                '& + .filter-item': {
                    borderTop: 'solid 1px rgba(3, 7, 31, 0.15)'
                },

            },
            '& .filter-pic': {
                marginRight: 16,
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
                width: 64,
                height: 64
            },
            "& .filter-time": {
                fontSize: "12px",
                color: "#bebebe"
            },
            "& .filter-title": {
                marginTop: "3px",
                fontSize: "16px",
                color: "#001229",
                fontWeight: "normal",
                lineHeight: "1.38",
                display: " -webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: "2"

            },
            "& .section-icon": {
                width: "26px",
                height: "12px",
                marginRight: "12px"
            },
            "& .section-title": {
                fontWeight: "bold"
            },
            "& .input-block": {
                position: "relative"
            },
            "& .email-input": {
                fontWeight: "normal",
                width: "100%",
                fontSize: "15px",
                padding: "8px 40px 8px 14px",
                backgroundColor: "#fff",
                color: "#001229",
                border: "1px solid #ebebeb"
            },
            "& .submit-icon": {
                cursor: "pointer",
                position: "absolute",
                top: "20px",
                right: "14px",
                width: "16px",
                height: "11px",
                transform: "translate(0px,-50%)"
            },
        },

    })
);

const MenuItemCustom = withStyles({
    root: {
        padding: '4px 0',
        minHeight: 'inherit',
        opacity: "0.5",
        "& a": {
            color: "#001229",
        },
        '&:hover': {
            opacity: "0.8",
            backgroundColor: 'transparent'
        }

    },
    selected: {
        opacity: "1",
        color: "#001229",
        backgroundColor: 'transparent !important'
    }
})(MenuItem);

const GoldMenu = withStyles({
    root: {
        fontWeight: "normal",
        padding: "6px 12px",
        border: "1px solid rgba(0,18,41,0.4)",
        borderRadius: 4,
        display: 'inline-block',
        minHeight: 'inherit',
        "& a": {
            color: 'rgba(3, 7, 31, 0.65)',
        },
        '&:hover': {
            "& a": {
                color: '#fff',
            },
            borderColor: '#001229',
            backgroundColor: '#001229'
        }
    },
    selected: {
        color: '#fff',
        borderColor: '#8b3d2b',
        backgroundColor: '#8b3d2b !important'
    }
})(MenuItem);

const NewsSidebar = (props: any) => {
    const { intl } = props
    const classes = useStyles();
    const dispatch = useDispatch();
    const global = useSelector((state: any) => state.global);
    const newsSelector = useSelector((state: any) => state.leadbest.news);
    const otherSelector = useSelector((state: any) => state.leadbest.other);
    const email = otherSelector.email
    const tags = newsSelector.tags
    const featureNews = newsSelector.featureNews
    const languagesIndex = languages[global.locale].id;

    const correspondingLanguage = (translations: any) => {
        const language = languagesIndex == 0 ? 'zh-TW' : 'en-US'
        return translations.find((item: any) => item.languages_id == language)
    }

    useEffect(() => {
        if (tags.loading || tags.loaded) return;
        dispatch(NewsActions.getTagsRequest({ params: {} }));
    }, [])

    useEffect(() => {
        if (featureNews.loading || featureNews.loaded) return;
        dispatch(NewsActions.getFeaturenewsRequest({ params: {} }));
    }, [])

    // subscription 
    const emptyFormData = { email: "" }
    const [formData, setFormData] = useState<any>({ ...emptyFormData })
    const [errorMessage, setErrorMessage] = React.useState<any>({});
    const validations: any = {
        email: [Validator.required, Validator.isEmail],
    };
    let validationField: any = ['email'];

    // const onInputChange = (e: any) => {
    //     Validator.onChangeValidate(e, validations, (res: any) => {
    //         setFormData({ ...formData, ...res.formData })
    //         setErrorMessage({ ...errorMessage, ...res.errorMessage })
    //     })
    // }
    // const onSubmit = () => {
    //     Validator.onSubmitValidate({
    //         validationField,
    //         validations,
    //         formData,
    //         onComplete: (res: any) => {
    //             setErrorMessage({ ...errorMessage, ...res.errorMessage })
    //             if (res.validBol) {
    //                 dispatch(OtherActions.postEmailRequest({ ...formData }));
    //             }
    //         }
    //     })
    // }

    function onInputChange(e: any) {
        const name = e.target.name;
        const value = e.target.value;

        let newFormData = conactFormData({ name, value, formData });
        setFormData(newFormData);

        if (validations[name]) {
            const validate = validation({ validations: validations[name], name, value });
            let newErrorMessage = { ...errorMessage, ...validate.errorMessage }
            setErrorMessage(newErrorMessage);
        }
    }

    const onSubmit = () => {
        let validBol: boolean = true;
        let newErrorMessage = { ...errorMessage }

        validationField.forEach((key: string) => {
            if (validBol && validations[key]) {
                const value = getMultilevelValue({ formData, name: key });

                const validate = validation({ validations: validations[key], name: key, value });
                newErrorMessage = { ...newErrorMessage, ...validate.errorMessage }
                validBol = validate.validBol;
            }
        });

        setErrorMessage(newErrorMessage);

        if (validBol) {
            dispatch(OtherActions.postEmailRequest({ ...formData }));
        }
    }
    useEffect(() => {
        if (!email.loaded) return;
        setFormData({ ...emptyFormData })
    }, [email.loaded])
    return (
        <Box className={classes.filter}>
            {!featureNews.loading && featureNews.loaded && featureNews.data.length > 5 &&
                <Box mb={6}>
                    <Box display="flex" alignItems="center">
                        <img className="section-icon" src={sectionIcon} alt="section-icon" />
                        <Typography className="section-title" variant="h5">{intl.formatMessage({ id: "newsSidebar.featuredNews" })}</Typography></Box>
                    {
                        featureNews.data.slice(5, 10).map((item: any, index: number) =>
                            <Link className="filter-item" to={`/news/${item.news_id.id}`} key={index}>
                                <Box className="filter-pic" style={{ backgroundImage: `url(${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.news_id.cover?.id}?fit=cover&width=64&height=64)` }}></Box>
                                <Box flex={1}>
                                    <Box className="filter-time">{moment(item.news_id.date_published).format('YYYY.MM.DD')}</Box>
                                    <Box className="filter-title">{correspondingLanguage(item.news_id.translations)?.title}</Box>
                                </Box>
                            </Link>
                        )
                    }
                </Box>
            }
            <Box mb={6}>
                <Box display="flex" alignItems="center" mb={3}>
                    <img className="section-icon" src={sectionIcon} alt="section-icon" />
                    <Typography variant="h5">{intl.formatMessage({ id: "newsSidebar.hashtag" })}</Typography></Box>
                <MenuList className={classes.btnGroup}>
                    {
                        !tags.loading && tags.loaded && (
                            tags.data.map((item: any, index: any) =>
                                <GoldMenu key={index}>
                                    <Link to={`/news-collection?${new URLSearchParams({ tag: item.name })}`}>
                                        {item.name}
                                    </Link>
                                </GoldMenu>
                            )
                        )
                    }
                </MenuList>
            </Box>

            <Box mb={6}>
                <Box display="flex" alignItems="center" mb={3}>
                    <img className="section-icon" src={sectionIcon} alt="section-icon" />
                    <Typography variant="h5">{intl.formatMessage({ id: "newsSidebar.category" })}</Typography>
                </Box>
                <MenuList className={classes.btnGroup}>
                    {
                        MenuTypes.map((item: any, index: any) =>
                            <MenuItemCustom key={index} selected={item == props.type} >
                                <Link to={`/news-collection?${new URLSearchParams({ type: item })}`}>{intl.formatMessage({ id: `newsList.menuType.${item}` })}</Link>
                            </MenuItemCustom>
                        )
                    }
                </MenuList>
            </Box>

            <Box mb={6}>
                <Box display="flex" alignItems="center" mb={3}>
                    <img className="section-icon" src={sectionIcon} alt="section-icon" />
                    <Typography variant="h5">{intl.formatMessage({ id: "newsSidebar.subscription" })}</Typography>
                </Box>
                <div className="input-block">
                    <FormControl fullWidth>
                        <TextField
                            disabled={email.loading}
                            value={formData.email}
                            name="email"
                            autoComplete="email"
                            color="secondary"
                            size="small"
                            margin="none"
                            label={intl.formatMessage({ id: "newsSidebar.subscription.placeholder" })} variant="outlined"
                            onChange={onInputChange}
                            error={!!errorMessage['email']}
                            helperText={errorMessage['email'] ? intl.formatMessage({ id: `${errorMessage[`email`]}` }) : ''}
                        />
                    </FormControl>
                    <img className="submit-icon" src={SubmitIcon} alt="submit-cion" onClick={onSubmit} />
                </div>
                <Snackbar />
            </Box>
        </Box >
    )
}
export default injectIntl(NewsSidebar)